import { Button } from '@/ui-lib/shadcn';
import { useTranslation } from 'react-i18next';
import type { FC } from 'react';
import { useEffect } from 'react';
import { systemConfig } from '@/features/i18n/system.config';

type Props = {
  title?: string;
  children?: never;
};

export const ForbiddenPage: FC<Props> = (props) => {
  const { t } = useTranslation(systemConfig.i18nNamespaces);
  const title = props.title ?? t('system:forbidden.title');

  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <>
      <div className="flex h-screen flex-col items-center justify-center gap-y-6 text-center">
        <h1 data-testid="not-found-title" className="text-5xl md:text-4xl lg:text-5xl">
          {title}
        </h1>
        <p className="text-2xl md:text-2xl lg:text-3xl">{t('system:forbidden.description')}</p>
        <Button className="text-center text-xl no-underline hover:underline">
          <a href={'/'}>{t('system:links.backToHome')}</a>
        </Button>
      </div>
    </>
  );
};
